// @ts-expect-error - TODO: AEN-33 - Should look at proper typings for the shape of our config
const getSanityUri = (config, datasetOverride?: string, mode?: string) => {
  const sanityConfig = config.get('sanity');
  const FILTERED_SUFFIX = '_filtered';
  const baseDataset = datasetOverride ?? sanityConfig.dataset;
  const dataset = `${baseDataset}${sanityConfig.useFiltered ? FILTERED_SUFFIX : ''}`;
  // Draft content is not served via CDN — bypass it when in draft mode
  const useCdn = mode === 'draft' ? false : sanityConfig.useCdn;
  return `https://${sanityConfig.projectId}.api${useCdn ? 'cdn' : ''}.sanity.io/v1/graphql/${dataset}/${
    sanityConfig.tag
  }`;
};

export default getSanityUri;
